import React from "react";
import { Snackbar, Slide } from "@mui/material";

const SnackBar = ({
  status = "success", 
  text = "Таны оруулсан мэдээлэл амжилттай шинэчлэгдэж орлоо.",
  showMessage = false, 
  closeMessage}) => {

  const SlideTransition = (props) => {
    return <Slide {...props} direction="up" />
  }

  //status --> success, error, warning, info, primary, secondary, light
  const getBgColor = () => (`bg-${status}`)
  const getIcon = () => {
    if (status === "success") return "bx bx-check-circle"
    else if (status === "error") return "bx bx-error-circle"
    return "bx bx-info-circle";
  }

  return (
    <Snackbar
      key={Math.random()}
      open={showMessage}
      autoHideDuration={6000}
      onClose={closeMessage}
      TransitionComponent={SlideTransition}
    >
      <div className={`main-snackbar ${getBgColor()}`}>
        <i className={`${getIcon()} text-white font-size-20`}></i>
        <div className="text-white font-size-14 mx-3">{text}</div>
        <div className="pointer" onClick={closeMessage}>
          <i className='bx bx-x text-white font-size-24'></i>
        </div>
      </div>
    </Snackbar>
  );
};


export default SnackBar;